import { PARAM_KEYS, REQUIRED_PARAM_KEYS } from '@/constants/parameters';

export default {
  namespaced: true,
  state: {
    [PARAM_KEYS.SITE_SLUG]: null,
    [PARAM_KEYS.SKUS]: null,
    [PARAM_KEYS.ZIP_CODE]: null,
    [PARAM_KEYS.START_DATE]: null,
    [PARAM_KEYS.END_DATE]: null,
    [PARAM_KEYS.VARIATION_ID]: null
  },
  mutations: {
    set(state, params) {
      state[PARAM_KEYS.SITE_SLUG] = params[PARAM_KEYS.SITE_SLUG];
      state[PARAM_KEYS.SKUS] = JSON.parse(params[PARAM_KEYS.SKUS]);
      state[PARAM_KEYS.ZIP_CODE] = params[PARAM_KEYS.ZIP_CODE];
      state[PARAM_KEYS.START_DATE] = params[PARAM_KEYS.START_DATE];
      state[PARAM_KEYS.END_DATE] = params[PARAM_KEYS.END_DATE];
      state[PARAM_KEYS.VARIATION_ID] = params[PARAM_KEYS.VARIATION_ID];
    }
  },
  getters: {
    uniqueSkus: (state) => {
      return [...new Set(state[PARAM_KEYS.SKUS])];
    },
    isMissingZipCode: (state, getters) => {
      return getters.isBlank(PARAM_KEYS.ZIP_CODE);
    },
    hasNoSkus: (state) => {
      return !state[PARAM_KEYS.SKUS].length;
    },
    isMissingRequiredParams: (state, getters) => {
      return REQUIRED_PARAM_KEYS.some((key) => getters.isBlank(key)) || getters.hasNoSkus;
    },
    isBlank: (state) => (key) => {
      const v = state[key];
      return v === null || v === '';
    }
  },
};
